<template>
  <p class="mb-5">
    <template v-if="typeof this.$props.link !== 'undefined'">
      <a
        :href="linkVal"
        target="_blank"
        class="btn btn-secondary btn-size-medium"
        @click="$emit('clicked')"
      >
        {{ textVal }}
      </a>
    </template>
    <template v-else>
      <button class="btn btn-secondary btn-size-medium" @click="$emit('clicked')">
        {{ textVal }}
      </button>
    </template>
  </p>
</template>

<script>
export default {
  props: ['link', 'text'],
  computed: {
    linkVal() {
      if (typeof this.$props.link !== 'undefined') return this.$props.link;
      else return '#';
    },
    textVal() {
      if (typeof this.$props.text !== 'undefined') return this.$props.text;
      else return 'Click Here';
    },
  },
};
</script>
